'use client';

import * as DS from '@aurorasolar/ds';
import { FormikHelpers } from 'formik';
import { Suspense, useContext } from 'react';

import { AIChatContext, ChatForm, ChatSuggestions, FormSchema } from '../../ai-chat/components';

type Props = { bg?: string };

const ChatSectionCore = ({ bg = 'uiBgAlternate' }: Props) => {
  const { openAiModal } = useContext(AIChatContext);

  const openChat = (question: string, formik?: FormikHelpers<FormSchema>) => {
    openAiModal(true, question);
    formik?.resetForm();
  };

  return (
    <DS.Flex bg={bg}>
      <DS.Flex gap={7} maxW={DS.BorealisTheme.screens.xl} mx="auto" px={{ _: 6, lg: 330 }} py={{ _: 7, lg: 10 }}>
        <ChatSuggestions onSuggestionClick={openChat} />
        <ChatForm autoFocus={false} onSubmit={async (values, formik) => openChat(values.text, formik)} />
      </DS.Flex>
    </DS.Flex>
  );
};

export const ChatSection = ({ bg }: Props) => (
  <Suspense>
    <ChatSectionCore bg={bg} />
  </Suspense>
);
